import { Injectable } from '@angular/core';

@Injectable()
export class LoggerService {

  log(...parameters) { console.log.apply( this, parameters ); }
  error(msg: any) { console.error(msg); }
  warn(msg: any) { console.warn(msg); }

}
